import React from 'react';
import CustomerForm from 'components/CustomerForm';
import Ship2Domestic from 'components/Domestic/Ship2Domestic';

const DomesticFlow = ({ step, initialValues }) => {

  return (
    <>
      <>{step == 1 && (<Ship2Domestic />)}</>
      <>{step == 2 && (<CustomerForm initialValues={initialValues} />)}</>
    </>
  );
};

export default DomesticFlow;